(function($) {
	'use strict';
	$.widget('msv.dropdown', {
		options: {
			limit: 6,
			text: '.form-item-text',
			optionsList: '.form-datalist__options',
			pointer: '.form-datalist__pointer',
			input: 'input[type=hidden]',
			removeBtn: '<a class="btn-remove-it icon-cross"></a>',
			removeBtnClass: '.remove-it'
		},
		vars: {},
		el: {},
		_create: function() {
			//---------- define vars and elements -----------------------------
			var self = this;
			self.vars = {};
			self.vars.required = self.element.data('required');
			self.vars.fieldName = self.element.data('name');
			self.vars.defaultText = self.element.find(self.options.text).val();
			self.vars.enableScroll = self.element.data('enable-scroll');
		},
		_init: function() {
			var self = this;

			self.element.find(self.options.text).click(function(e) {
				self.populate();
				self.open();
			});
			self.element.find(self.options.text).blur(function(e) {
				setTimeout(function() {
					self.close();
				}, 200);
			});
			self.element.find(self.options.pointer).mouseup(function() {
				if (self.element.hasClass("opened")) {
					self.close();
				}
				else {
					self.populate();
					self.open();
				}
			});

			self.element.find(self.options.optionsList).on('click', function(item) {
				if (self.element.find(self.options.optionsList)[0] == item.target)
					return false;

				self.updateValue(item);

				self.close();
			});

			$(window).resize(function() {
				self.redraw();
			});

			if (self.vars.enableScroll) {
				self.element.find(self.options.optionsList)
					.css({ 'overflow-y': 'auto', 'max-height': '300px' });
			}
		},
		updateValue: function(selectedOption) {
			var self = this;
			var inputHidden = self.element.find('input[type=hidden]');
			var inputText = self.element.find('input[type=text]');
			var selectedValue = selectedOption ? selectedOption == 'reset' ? null : $(selectedOption.target).data('value') : inputHidden.val();
			var selectedText = selectedOption ? selectedOption == 'reset' ? null : $(selectedOption.target).text() : inputText.val();
			var selectedLimit = selectedOption ? selectedOption == 'reset' ? null : $(selectedOption.target).data("limit") !== 'undefined' ? $(selectedOption.target).data('limit') : '' : '';

			if (selectedLimit)
				$('.js-atendees').attr('max', selectedLimit)

			inputText.val(selectedText).attr('data-value', selectedValue);
			inputHidden.val(selectedValue).trigger('change');

			if (inputHidden.val()) {
				self.element.find('.btn-remove-it').remove();
				self.element.addClass('has-value');
				self.vars.btnRemove = $(self.options.removeBtn).off('click').click(function() {
					inputHidden.val(null).trigger('change');
					inputText.val(null);
					self.updateValue('reset');
				});

				self.element.append(self.vars.btnRemove);

				inputHidden.valid();
				inputText.valid();
			}
			else {
				self.element.removeClass('has-value');
				self.element.find('.btn-remove-it').remove();
			}
		},
		_destroy: function() {},
		open: function() {
			var self = this;
			self.element.addClass("opened");
			self.redraw();
			self.element.find(self.options.text).focus();
		},

		close: function() {
			var self = this;
			self.element.removeClass("opened");
		},

		redraw: function() {
			var self = this;
			//console.log('redraw');
			self.element.find(self.options.optionsList).width(self.element.find(self.options.text).width() + 2);
		},
		populate: function() {
			var self = this;
			self.element.find(self.options.optionsList).empty();

			//-------------------  hide-option-if algorithm ---------------
			var hideOptionIf = self.element.data('hide-option-if');
			var optionValue = null;
			var hideOption = false;
			if (hideOptionIf) {
				//{"complaint":{"userType":"is-not-customer"}}
				optionValue = Object.keys(hideOptionIf) && Object.keys(hideOptionIf).length > 0 ? Object.keys(hideOptionIf)[0] : null; //complaint
				var condition = optionValue ? hideOptionIf[optionValue] : null;
				var inputControllerName = condition && Object.keys(condition) && Object.keys(condition).length > 0 ? Object.keys(condition)[0] : null; //userType
				//$('[name=' + inputControllerName + ']').change(function () {
				//    console.log(this);
				//});
				var inputControllerTargetValue = condition ? condition[inputControllerName] : null; //is-not-customer
				var inputControllerValue = $.getFieldFormValue(self.element.closest('form'), inputControllerName); //(currentValue)

				hideOption = inputControllerTargetValue == inputControllerValue;
			}
			self.updateValue();
			//----------------------------------------------------------------

			$.each(self.element.data('json'), function(index, item) {
				if (!(hideOption && item.value == optionValue)) { //hide-option-if algorithm : CONDITION
					//self.reset();
					var option = $('<div class="form-datalist-item" data-limit="' + item.limit + '" data-value="' + item.value + '">' + item.text + "</div>");
					option.click(self, function(e) {
						var mapElementId = $(e.data.element).data('bind-map');
						if (mapElementId)
							$(mapElementId).googlemap('focusMarkerById', item.value);
					});
					self.element.find(self.options.optionsList).append(option);
				}
			});

		},
		reset: function() {
			var self = this;
			self.element.find(self.options.input).val('').trigger('change');
			self.updateValue();
			self.element.find(self.options.text).val(self.vars.defaultText);
		}
	});
})(jQuery);